import React from 'react';
import { Box, Typography, Button, Alert } from '@mui/material';

interface ErrorBoundaryProps {
  error: string;
  onRetry?: () => void;
  title?: string;
}

export const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({ 
  error, 
  onRetry,
  title = "Error Loading Data"
}) => {
  return (
    <Box 
      sx={{ 
        p: 3, 
        textAlign: 'center',
        maxWidth: 600,
        margin: '0 auto'
      }}
    >
      <Alert severity="error" sx={{ mb: 3 }}>
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
        <Typography variant="body1" gutterBottom>
          {error}
        </Typography>
      </Alert>
      
      {onRetry && (
        <Button 
          variant="contained" 
          color="primary" 
          onClick={onRetry}
          sx={{ mt: 2 }}
        >
          Try Again
        </Button>
      )}
    </Box>
  );
};
